import { BOOKING_FLOW_CONFIGS, BOOKING_STEP } from '../constants/AppConstants'

const DEFAULT_BOOKING_STEPS = [
  BOOKING_STEP.CAR_INFO,
  BOOKING_STEP.SERVICE_INFO,
  BOOKING_STEP.DATE_LOCATION_INFO,
  BOOKING_STEP.CUSTOMER_INFO
]

const GARAGE_BOOKING_STEPS = [BOOKING_STEP.SERVICE_INFO, BOOKING_STEP.GARAGE_DATE_LOCATION_INFO]
class BookingStepsConfig {
  constructor() {
    this.activeConfig = BOOKING_FLOW_CONFIGS.DEFAULT_FLOW
  }

  setActiveConfig(flowName) {
    this.activeConfig = flowName
  }

  getActiveConfig() {
    switch (this.activeConfig) {
      case BOOKING_FLOW_CONFIGS.DEFAULT_FLOW:
        return DEFAULT_BOOKING_STEPS

      case BOOKING_FLOW_CONFIGS.GARAGE_FLOW:
        return GARAGE_BOOKING_STEPS

      default:
        return DEFAULT_BOOKING_STEPS
    }
  }
}

export default new BookingStepsConfig()



// WEBPACK FOOTER //
// ./src/configs/BookingStepsConfig.js